import React, { useEffect, useState } from 'react';
import { UserConsigneeService } from 'services';
import { useIsUser, useStore } from 'hooks';
import Menu from 'components/menu';
import Table from 'components/table';
import Actions from 'components/table/actions';
import Modal from 'components/modal';
import Consignee from 'components/modal/consignee';
import { Input } from 'components/ui/form';
import styles from './consignees.module.scss';

const DEFAULT_LIMIT = 20;

const ConsigneePage = ({
  match: {
    params: { userId },
  },
}) => {
  const { reload, setUser, setLoading, setReload } = useStore();
  const [modal, setModal] = useState(false);
  const [data, setData] = useState([]);
  const [count, setCount] = useState(0);
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(DEFAULT_LIMIT);
  const [searchQuery, setSearchQuery] = useState('');
  const isUser = useIsUser();

  useEffect(() => {
    let cancelled = false;

    async function fetchData() {
      setLoading(true);
      const params = { userId, page, limit };
      if (searchQuery.trim()) {
        params.search = searchQuery.trim();
      }
      const response = await new UserConsigneeService({ setUser }).getConsignees(params);
      setLoading(false);

      if (cancelled || !response) return;
      if (Array.isArray(response)) {
        setData(response);
        setCount(response.length);
      } else if (response.items != null) {
        setData(response.items);
        setCount(response.count ?? 0);
      }
    }

    fetchData();
  }, [userId, reload, page, limit, searchQuery, setUser, setLoading]);

  const onOpenModal = () => setModal(true);

  const onCloseModal = (isReload = false) => {
    setModal(false);
    if (isReload) {
      setReload();
    }
  };

  const onDelete = async ({ id }) => {
    await new UserConsigneeService({ setUser }).deleteConsignee({ id });
    setReload();
  };

  const onArchive = async ({ id }, status) => {
    await new UserConsigneeService({ setUser }).archive({ id, status });
    setReload();
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
    setPage(0);
  };

  const cells = [{
    name: 'Грузополучатель',
    renderField: 'consignee.name',
  }, {
    name: 'Адрес грузо-ля',
    renderField: 'consignee.address',
  }, {
    name: 'ЖД код грузо-ля',
    renderField: 'consignee.codeGd',
  }, {
    name: 'В архиве',
    renderField: 'consignee.isArchive',
    onRender: ({ isArchive }) => isArchive ? 'да' : 'нет',
  }, ...(isUser ? [{
    name: '',
    right: true,
    nowrap: true,
    onRender: (item) => {
      const { isArchive } = item;

      return (
        <Actions
          data={[{
            name: 'folder',
            title: isArchive ? 'Вернуть из архива' : 'В архив',
            onClick: () => onArchive(item, !isArchive),
          }, {
            name: 'cart',
            title: 'Удалить',
            onClick: () => onDelete(item),
          }]}
        />
      );
    },
  }] : [])];

  return (
    <>
      <div className={styles.menu}>
        <Menu onAdd={isUser ? onOpenModal : false} />
      </div>
      <div className={styles.searchWrap}>
        <Input
          type="text"
          value={searchQuery}
          onChange={handleSearchChange}
          placeholder="Поиск по названию, адресу, коду ЖД, УНП"
        />
      </div>
      <div className={styles.table}>
        <Table
          cells={cells}
          data={data}
          count={count}
          page={page}
          limit={limit}
          onPageChange={({ selected }) => setPage(selected)}
          onLimitChange={(newLimit) => {
            setLimit(newLimit);
            setPage(0);
          }}
        />
      </div>
      {isUser && modal ? (
        <Modal closeBackground={false} onClose={onCloseModal}>
          <Consignee onClose={onCloseModal} />
        </Modal>
      ) : null}
    </>
  );
};

export default ConsigneePage;
